const CONSENT_ENABLED = false;
const CONSENT_COOKIE = "cartells-consent-v1";
const CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 180;
const callbacks = {
  analytics: new Set(),
  advertising: new Set(),
};

const translations = {
  ca: {
    title: "Privacitat i cookies",
    intro:
      "Utilitzem cookies tècniques per fer funcionar Cartells. Amb el teu permís, també podem utilitzar Google Analytics per mesurar l’ús del servei i Google AdSense per mostrar publicitat.",
    necessary: "Cookies tècniques necessàries",
    necessaryHelp: "Sempre actives perquè el servei pugui funcionar.",
    analytics: "Analítica",
    analyticsHelp: "Google Analytics ens ajuda a entendre com s’utilitza Cartells.",
    advertising: "Publicitat",
    advertisingHelp: "Google AdSense pot mostrar anuncis i mesurar-ne el rendiment.",
    accept: "Accepta-ho tot",
    reject: "Rebutja-ho tot",
    configure: "Configura",
    save: "Desa la selecció",
    settings: "Configura les cookies",
    privacy: "Més informació",
  },
  es: {
    title: "Privacidad y cookies",
    intro:
      "Utilizamos cookies técnicas para que Cartells funcione. Con tu permiso, también podemos utilizar Google Analytics para medir el uso del servicio y Google AdSense para mostrar publicidad.",
    necessary: "Cookies técnicas necesarias",
    necessaryHelp: "Siempre activas para que el servicio pueda funcionar.",
    analytics: "Analítica",
    analyticsHelp: "Google Analytics nos ayuda a entender cómo se utiliza Cartells.",
    advertising: "Publicidad",
    advertisingHelp: "Google AdSense puede mostrar anuncios y medir su rendimiento.",
    accept: "Aceptar todo",
    reject: "Rechazar todo",
    configure: "Configurar",
    save: "Guardar selección",
    settings: "Configurar las cookies",
    privacy: "Más información",
  },
  fr: {
    title: "Confidentialité et cookies",
    intro:
      "Nous utilisons des cookies techniques pour faire fonctionner Cartells. Avec votre accord, nous pouvons également utiliser Google Analytics pour mesurer l’utilisation du service et Google AdSense pour afficher de la publicité.",
    necessary: "Cookies techniques nécessaires",
    necessaryHelp: "Toujours actifs pour assurer le fonctionnement du service.",
    analytics: "Mesure d’audience",
    analyticsHelp: "Google Analytics nous aide à comprendre l’utilisation de Cartells.",
    advertising: "Publicité",
    advertisingHelp: "Google AdSense peut afficher des annonces et mesurer leurs performances.",
    accept: "Tout accepter",
    reject: "Tout refuser",
    configure: "Configurer",
    save: "Enregistrer la sélection",
    settings: "Configurer les cookies",
    privacy: "En savoir plus",
  },
  en: {
    title: "Privacy and cookies",
    intro:
      "We use technical cookies to make Cartells work. With your permission, we may also use Google Analytics to measure use of the service and Google AdSense to display advertising.",
    necessary: "Necessary technical cookies",
    necessaryHelp: "Always active so the service can work.",
    analytics: "Analytics",
    analyticsHelp: "Google Analytics helps us understand how Cartells is used.",
    advertising: "Advertising",
    advertisingHelp: "Google AdSense may display ads and measure their performance.",
    accept: "Accept all",
    reject: "Reject all",
    configure: "Configure",
    save: "Save selection",
    settings: "Cookie settings",
    privacy: "More information",
  },
};

let consent = readConsent();
let banner;
let settingsButton;

function ensureStylesheet() {
  if (document.querySelector('link[data-consent-styles]')) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "/consent.css";
  link.dataset.consentStyles = "";
  document.head.append(link);
}

function getLanguage() {
  const language = (document.documentElement.lang || "ca").toLowerCase().split("-")[0];
  return translations[language] ? language : "ca";
}

function getText() {
  return translations[getLanguage()];
}

function getPrivacyUrl() {
  const language = getLanguage();
  if (language === "ca") return "https://yuppiya.com/legal/#cookies";
  return `https://yuppiya.com/${language}/legal/#cookies`;
}

function readConsent() {
  const prefix = `${CONSENT_COOKIE}=`;
  const value = document.cookie
    .split(";")
    .map((item) => item.trim())
    .find((item) => item.startsWith(prefix));

  if (!value) return null;

  try {
    const parsed = JSON.parse(decodeURIComponent(value.slice(prefix.length)));
    if (
      typeof parsed.analytics !== "boolean" ||
      typeof parsed.advertising !== "boolean"
    ) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

function writeConsent(nextConsent) {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${CONSENT_COOKIE}=${encodeURIComponent(
    JSON.stringify(nextConsent),
  )}; Max-Age=${CONSENT_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
}

function runAllowedCallbacks() {
  Object.entries(callbacks).forEach(([category, categoryCallbacks]) => {
    if (!consent?.[category]) return;
    categoryCallbacks.forEach((callback) => callback());
    categoryCallbacks.clear();
  });
}

function clearGoogleCookies() {
  const names = document.cookie
    .split(";")
    .map((item) => item.trim().split("=")[0])
    .filter((name) => /^(_ga|_gid|_gat|__gads|__gpi)/.test(name));
  const hostnameParts = window.location.hostname.split(".");
  const parentDomain =
    hostnameParts.length > 2 ? `.${hostnameParts.slice(-2).join(".")}` : null;

  names.forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; Path=/`;
    if (parentDomain) {
      document.cookie = `${name}=; Max-Age=0; Path=/; Domain=${parentDomain}`;
    }
  });
}

function saveConsent(analytics, advertising) {
  const previousConsent = consent;
  consent = {
    analytics,
    advertising,
    updatedAt: new Date().toISOString(),
  };
  writeConsent(consent);
  closeBanner();
  const revoked =
    (previousConsent?.analytics && !analytics) ||
    (previousConsent?.advertising && !advertising);
  if (revoked) {
    clearGoogleCookies();
    window.location.reload();
    return;
  }
  showSettingsButton();
  runAllowedCallbacks();
}

function createChoice(name, label, help, checked, disabled = false) {
  const wrapper = document.createElement("label");
  wrapper.className = "consent-choice";

  const input = document.createElement("input");
  input.type = "checkbox";
  input.name = name;
  input.checked = checked;
  input.disabled = disabled;

  const copy = document.createElement("span");
  const title = document.createElement("strong");
  title.textContent = label;
  const description = document.createElement("small");
  description.textContent = help;
  copy.append(title, description);
  wrapper.append(input, copy);

  return wrapper;
}

function showConfiguration(container, text) {
  container.replaceChildren(
    createChoice("necessary", text.necessary, text.necessaryHelp, true, true),
    createChoice(
      "analytics",
      text.analytics,
      text.analyticsHelp,
      Boolean(consent?.analytics),
    ),
    createChoice(
      "advertising",
      text.advertising,
      text.advertisingHelp,
      Boolean(consent?.advertising),
    ),
  );
  container.hidden = false;
  const panel = container.closest(".consent-panel");
  panel.querySelector("[data-consent-save]").hidden = false;
  panel.querySelector("[data-consent-configure]").hidden = true;
}

function showBanner(configure = false) {
  ensureStylesheet();
  if (banner) {
    if (configure) {
      showConfiguration(
        banner.querySelector("[data-consent-options]"),
        getText(),
      );
    }
    banner.querySelector("h2").focus();
    return;
  }

  const text = getText();
  banner = document.createElement("section");
  banner.className = "consent-banner";
  banner.setAttribute("role", "dialog");
  banner.setAttribute("aria-labelledby", "consent-title");

  const panel = document.createElement("div");
  panel.className = "consent-panel";

  const title = document.createElement("h2");
  title.id = "consent-title";
  title.tabIndex = -1;
  title.textContent = text.title;

  const intro = document.createElement("p");
  intro.textContent = text.intro;

  const privacy = document.createElement("a");
  privacy.href = getPrivacyUrl();
  privacy.textContent = text.privacy;

  const options = document.createElement("div");
  options.className = "consent-options";
  options.dataset.consentOptions = "";
  options.hidden = true;

  const actions = document.createElement("div");
  actions.className = "consent-actions";

  const accept = document.createElement("button");
  const reject = document.createElement("button");
  reject.type = "button";
  reject.dataset.consentReject = "";
  reject.textContent = text.reject;
  reject.addEventListener("click", () => saveConsent(false, false));

  accept.type = "button";
  accept.dataset.consentAccept = "";
  accept.textContent = text.accept;
  accept.addEventListener("click", () => saveConsent(true, true));

  const configureButton = document.createElement("button");
  configureButton.type = "button";
  configureButton.className = "consent-secondary";
  configureButton.textContent = text.configure;
  configureButton.dataset.consentConfigure = "";
  configureButton.addEventListener("click", () =>
    showConfiguration(options, text),
  );

  const save = document.createElement("button");
  save.type = "button";
  save.className = "consent-secondary";
  save.dataset.consentSave = "";
  save.hidden = true;
  save.textContent = text.save;
  save.addEventListener("click", () => {
    saveConsent(
      options.querySelector('[name="analytics"]').checked,
      options.querySelector('[name="advertising"]').checked,
    );
  });

  actions.append(reject, configureButton, accept, save);
  panel.append(title, intro, privacy, options, actions);
  banner.append(panel);
  document.body.append(banner);

  if (configure) showConfiguration(options, text);
  title.focus();
}

function closeBanner() {
  banner?.remove();
  banner = null;
}

function showSettingsButton() {
  if (settingsButton) return;
  ensureStylesheet();
  settingsButton = document.createElement("button");
  settingsButton.type = "button";
  settingsButton.className = "consent-settings";
  settingsButton.setAttribute("aria-label", getText().settings);
  settingsButton.title = getText().settings;
  settingsButton.innerHTML =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M20.4 10.2a4 4 0 0 1-5.2-5.2A8.5 8.5 0 1 0 20.4 10.2Z"/>' +
    '<circle cx="8" cy="10" r="1"/><circle cx="11" cy="16" r="1"/>' +
    '<circle cx="6.5" cy="15" r=".8"/></svg>';
  settingsButton.addEventListener("click", () => showBanner(true));
  document.body.append(settingsButton);
}

function consentRequest(category, callback) {
  if (!callbacks[category]) {
    throw new Error(`Unknown consent category: ${category}`);
  }

  if (!CONSENT_ENABLED) {
    callback();
    return;
  }

  if (consent?.[category]) {
    showSettingsButton();
    callback();
    return;
  }

  callbacks[category].add(callback);
  if (!consent) showBanner();
  else showSettingsButton();
}

export { consentRequest };
